import { Check, Clock, FileText } from "lucide-react";

const NAVY = "#0E2550";
const MINT = "#14B88F";

const DOCS = [
  ["Cartão de cidadão", "válido até 2031", "ok"],
  ["Caderneta predial", "lida e confirmada", "ok"],
  ["Certidão permanente", "válida até 14 dez", "ok"],
  ["Certificado energético", "pedido ao cliente há 2 dias", "wait"],
];

function Doc({ name, sub, state }) {
  return (
    <li className="flex items-center gap-3 py-2.5">
      <span className={`w-6 h-6 rounded-full grid place-items-center shrink-0 ${state === "ok" ? "text-white" : "bg-amber-50 text-amber-600"}`} style={state === "ok" ? { background: MINT } : undefined}>
        {state === "ok" ? <Check size={14} strokeWidth={3} /> : <Clock size={13} />}
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-[13px] font-semibold truncate" style={{ color: NAVY }}>{name}</span>
        <span className="block text-[11.5px] text-slate-500 truncate">{sub}</span>
      </span>
    </li>
  );
}

export function LandingMockup() {
  return (
    <div className="relative" aria-label="Exemplo da aplicação ImoDesk com dados fictícios" role="img" data-testid="landing-mockup">
      <div className="rounded-2xl border border-slate-200 bg-white shadow-[0_30px_80px_-30px_rgba(14,37,80,0.35)] overflow-hidden">
        <div className="flex items-center gap-1.5 px-4 h-9 border-b border-slate-100 bg-slate-50/70">
          <span className="w-2.5 h-2.5 rounded-full bg-slate-200" /><span className="w-2.5 h-2.5 rounded-full bg-slate-200" /><span className="w-2.5 h-2.5 rounded-full bg-slate-200" />
          <span className="ml-3 text-[11px] text-slate-400">Casa Atlântico · Processos</span>
        </div>
        <div className="p-5 sm:p-6">
          <div className="text-[11px] font-bold tracking-[0.14em] uppercase text-slate-400">Angariação · CA-0142</div>
          <div className="mt-1 text-lg sm:text-xl font-bold leading-tight" style={{ color: NAVY }}>T3 · Rua das Gaivotas 12, Cascais</div>
          <div className="text-[12.5px] text-slate-500 mt-0.5">Proprietária Inês Moura · consultor Rui Teixeira</div>
          <div className="mt-4 flex items-center gap-2 rounded-lg px-3 py-2 text-[12.5px] font-semibold" style={{ background: "#E9F8F3", color: "#0B7A5E" }}>
            <Check size={15} strokeWidth={3} /> Tem todos os dados para o contrato de mediação
          </div>
          <ul className="mt-3 divide-y divide-slate-100">{DOCS.map(([n, s, st]) => <Doc key={n} name={n} sub={s} state={st} />)}</ul>
          <div className="mt-4 grid grid-cols-[1fr_auto] gap-2">
            <span className="rounded-lg text-white text-[13px] font-semibold py-2.5 text-center" style={{ background: NAVY, boxShadow: `0 0 0 3px ${MINT}33` }}>Gerar CMI</span>
            <span className="rounded-lg border border-slate-200 text-[13px] font-semibold px-3 py-2.5" style={{ color: NAVY }}>Lembrar</span>
          </div>
        </div>
      </div>
      <div className="hidden sm:flex absolute -left-6 -bottom-6 items-center gap-3 rounded-xl bg-white border border-slate-200 shadow-lg px-4 py-3">
        <FileText size={18} style={{ color: MINT }} />
        <div>
          <div className="text-[12.5px] font-semibold" style={{ color: NAVY }}>Inês enviou a caderneta</div>
          <div className="text-[11px] text-slate-500">pelo link da agência · há 5 min</div>
        </div>
      </div>
    </div>
  );
}
